import { cn } from "@/utils/utils";
import { IconBox } from "@common/components";
import { Body, Heading } from "@hypercard/web-components";
import { Warning } from "@phosphor-icons/react";

type Props = {
  className?: string;
};

export const Error = ({ className }: Props) => {
  return (
    <div
      className={cn(
        "flex h-full w-full flex-col items-center justify-center",
        className,
      )}
    >
      <IconBox className="h-12 w-12 rounded-lg">
        <Warning className="size-6" />
      </IconBox>
      <Heading size="md" weight="medium" className="mt-6 text-center">
        Error Loading Report
      </Heading>
      <Body
        size="sm"
        weight="regular"
        className="mt-4 text-center text-white/70"
      >
        There was an error loading this report. Please try again.
      </Body>
    </div>
  );
};
